import type { FlattenSimpleInterpolation } from 'styled-components';
import styled, { css } from 'styled-components';

export const truncateText = (lines: number): FlattenSimpleInterpolation => css`
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const TruncatedSpan = styled.span<{ lines: number }>`
    word-break: break-word; /* Deprecated - but the only thing that works here. */
    ${({ lines }) => truncateText(lines)}
`;

export const TextOverflow = styled.div`
    width: 100%;
    flex-shrink: 1;
    min-width: 0;

    > * {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

export const LineClamp = styled.div<{ lines?: number }>`
    > * {
        word-break: break-word; /* Deprecated - but the only thing that works here. */
        text-overflow: ellipsis;
        ${props => truncateText(props.lines || 2)}
    }
`;
